import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import { LgvTSHelper } from "./ts-helper";
import { LgvModel } from "../../data-models/longevity.model";
import { LgvStatesHelper } from "./lgv-states-helper";

export function ObjectValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {

        return typeof control.value !== 'object' || control.value === null ? { 'forbiddenObject': true } : null;

    }
}

export function GreaterThanZero(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;
        return value <= 0 ? { 'lessThanZero': true } : null;

    }
}

export function ValidStateCode(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;
        return !LgvTSHelper.isValidStateCode(value) ? { 'invalidStateCode': true } : null;
    }
}

export function IsNotObject(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;
        return typeof value === 'object' && value !== null ? null : { 'isNotObject': true };
    }
}

export function ValAvsB(textA: string, textB:string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {

        if (control && control.parent) {
            let valA = control.parent.get(textA)?.value;
            let valB = control.parent.get(textB)?.value;
            let hasComparisonError = !!+valA && !!+valB && +valB >= +valA;
            //console.log(`Comparison: ${valB} | ${valA} | ${hasComparisonError} | ${textA} | ${textB}`);
            return hasComparisonError ? { 'comparison': true } : null;
        }
        return null;
    }
}

export class ConfirmPasswordValidator {
    /**
     * Check matching password with confirm password
     * @param control AbstractControl
     */
    static matchPassword(control: AbstractControl) {
        const password = control.get('password').value;

        const confirmPassword = control.get('confirmPassword').value;

        if (password !== confirmPassword) {
            control.get('confirmPassword').setErrors({ unmatchedPassword: true });
        } else {
            return null;
        }
    }
}

export function LicensedStateCode(agentSS: LgvModel.AgentSS): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;
        if (!value) return null;

        // Get all unique states from agent and company licenses
        const agentStates = (agentSS?.agentInfo?.stateLicenses || [])
            .filter(license => license.status === 'Approved' || license.status === 'Approved - Inactive')
            .map(license => LgvStatesHelper.getStateAbbreviation(license.state));
            
        const companyStates = (agentSS?.company?.stateLicenses || [])
            .filter(license => license.status === 'Approved' || license.status === 'Approved - Inactive')
            .map(license => LgvStatesHelper.getStateAbbreviation(license.state));

        const isLicensedByBoth = agentStates.includes(value) && companyStates.includes(value);

        return agentStates.length > 0 && companyStates.length > 0 && !isLicensedByBoth
            ? { 'unlicensedState': true } 
            : null;
    }
}
